import React, { useState,useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser, faLock, faEnvelope, faPhone, faBuilding,
  faIdBadge, faBriefcase, faEye, faEyeSlash, faUserPlus
} from '@fortawesome/free-solid-svg-icons';
import { NavLink, useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import { Contenedorimagen2 } from './ContenedorImagen2';
import '../login.css';
const api=process.env.REACT_APP_API;


function Formulario() {
  let History = useHistory();
    const [instituciones,setInstituciones]=useState([]);
    const [area,setArea]=useState([]);
    const [nombre,setNombre]=useState("");
    const [apellido,setApellido]=useState("");
    const [nombreUsuario,setNombreUsuario]=useState("");
    const [correo,setCorreo]=useState("");
    const [telefono,setTelefono]=useState("");
    const [edificio,setEdificio]=useState("");
    const [institucion,setInstitucion]=useState("");
    const [nombreArea,setNombreArea]=useState("");
    const [contrasena,setContrasena]=useState("");
    const [cContrasena,setCContrasena]=useState("");
    const [verPass, setVerPass] = useState(false);
    const [verPass2, setVerPass2] = useState(false);
 
    const consultarArea = async () => {
      const res = await fetch(`${api}/area`);
      const data = await res.json();
      setArea(data);
    };



    const enviar=async(e)=>{
      e.preventDefault();

        if(nombre==="" || apellido==="" || nombreUsuario==="" || correo==="" || telefono==="" || edificio==="" || institucion==="" || nombreArea==="" || contrasena==="" || cContrasena===""){
           swal({
              title: "Validacion de Datos",
              text: "Todos los campos deben de estar llenos",
              icon: "warning",
              button: "Aceptar"
            })
          }else if(contrasena.length<8){
            swal({
              title: "Validacion de Datos",
              text: "La contraseña debe de Tener Mas de 8 Caracteres",
              icon: "warning",
              button: "Aceptar"
            })
          }else if(contrasena!==cContrasena){ 
            swal({
              title: "Validacion de Datos",
              text: "La Contraseña no Coincide con la Confirmación",
              icon: "warning",
              button: "Aceptar"
            })
          }else{

            swal({
              text: 'Ingrese Código de Verificación de Su Institución',
              content: "input",
              button: {
                text: "Agregar",
                closeModal: false,
              },
            }).then(async codigo=>{
              const res = await fetch(`${api}/consultarCodigo`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    institucion,
                    codigo
                })
              })    


              const data = await res.json();

              if(data[0]==="Correcto"){
                const res = await fetch(`${api}/agregarInfoUsuario`, {
                  method: 'PUT',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                      nombre,
                      apellido,
                      nombreUsuario,
                      correo,
                      contrasena,
                      cContrasena,
                      telefono,
                      edificio,
                      institucion,
                      nombreArea
                  })
                  
            })
            
            const data = await res.json();
            if(data[0]==="Rechazado"){
              swal({
                title: "Error al Crear Usuario",
                text: " Ya existe Usuario Asociado al correo Electónico: "+correo,
                icon: "error",
                button: "Aceptar"
              })
            }else if(data[0]==="Confirmado"){
              
              swal({
                title: "Usuario "+correo+ " Creado Exitosamente",
                icon: "success",
                button: "Aceptar"
              })

               await fetch(`${api}/confirmacion`, {
                method: 'Post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    nombre,
                    apellido,
                    nombreUsuario,
                    correo,
                })
              })
  
              setNombre("")
              setApellido("")
              setNombreUsuario("")
              setCorreo("")
              setContrasena("")
              setCContrasena("")
              setTelefono("")
              setEdificio("")
              setInstitucion("")
              setNombreArea("")
  
              setTimeout(()=>History.push(`/inicio`),2000);
              
            }
  
              }else{
  
                swal({
                  title: "Error al Crear Usuario",
                  text: "No se Puede Crear el Usuario Porque el Código Ingresado es Incorrrecto",
                  icon: "error",
                  button: "Aceptar"
                })
              }
  

            })
      
           
          

        }
    }

    useEffect(() => {
      consultarArea()
    }, [])

  const fieldStyle = {
    display: 'flex', flexDirection: 'column', gap: 6,
  };
  const labelStyle = {
    fontSize: '0.88rem', fontWeight: 600, color: 'rgba(220,235,255,0.88)', marginBottom: 0,
  };
  const rowStyle = {
    display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16,
  };
  const inputBox = {
    display: 'flex', alignItems: 'stretch',
    borderRadius: 10, border: '1px solid rgba(183,208,233,0.35)',
    background: 'rgba(255,255,255,0.92)', overflow: 'hidden',
    minHeight: 44, transition: 'border-color 0.2s, box-shadow 0.2s',
  };
  const iconBox = {
    width: 40, display: 'grid', placeItems: 'center',
    color: '#1f3e67', background: '#edf2f7',
    fontSize: '0.95rem', borderRight: '1px solid rgba(158,178,199,0.5)',
    flexShrink: 0,
  };
    const formCss = `
      .rs-form-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
      }
      @media (max-width: 560px) {
        .rs-form-row { grid-template-columns: 1fr; gap: 10px; }
        .rs-form-outer { padding: 14px 10px !important; align-items: flex-start !important; padding-top: 20px !important; }
        .rs-form-wrap { padding: 18px 14px !important; border-radius: 16px !important; }
        .rs-form-avatar { width: 58px !important; height: 58px !important; margin-bottom: 10px !important; }
        .rs-form-title { font-size: 1.3rem !important; }
        .rs-form-subtitle { font-size: 0.86rem !important; }
      }
    `;

  const inputEl = {
    flex: 1, border: 'none', outline: 'none',
    padding: '10px 12px', fontSize: '0.95rem',
    color: '#173654', background: 'transparent',
  };
  const selectEl = {
    flex: 1, border: 'none', outline: 'none',
    padding: '10px 12px', fontSize: '0.95rem',
    color: '#173654', background: 'transparent', cursor: 'pointer',
  };
  const eyeBtn = {
    background: 'none', border: 'none', cursor: 'pointer',
    padding: '0 12px', color: '#1f3e67', fontSize: 15,
    display: 'flex', alignItems: 'center', flexShrink: 0,
  };

  return (
    <div className='principal'>
      <Contenedorimagen2>
        <style>{formCss}</style>
        <div className="rs-form-outer" style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center',
          justifyContent: 'center', padding: '32px 16px',
        }}>
          <div className="rs-form-wrap" style={{
            width: '100%', maxWidth: 780,
            background: 'rgba(9,18,33,0.62)',
            border: '1px solid rgba(187,215,246,0.22)',
            borderRadius: 20,
            backdropFilter: 'blur(12px)',
            boxShadow: '0 20px 50px rgba(0,0,0,0.38)',
            padding: 'clamp(20px,3vw,36px)',
            color: '#f0f4ff',
          }}>

            {/* Header */}
            <div style={{ textAlign: 'center', marginBottom: 28 }}>
              <div className="rs-form-avatar" style={{
                width: 76, height: 76, borderRadius: '50%', margin: '0 auto 14px',
                background: 'radial-gradient(circle at 30% 20%,#2b87ff 0%,#1d4ed8 55%,#1e3a8a 100%)',
                border: '3px solid rgba(255,255,255,0.25)',
                boxShadow: '0 10px 24px rgba(6,20,45,0.55)',
                display: 'grid', placeItems: 'center',
              }}>
                <FontAwesomeIcon icon={faUserPlus} style={{ fontSize: 32, color: '#fff' }} />
              </div>
                <h3 className="rs-form-title" style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: '1.55rem', margin: 0 }}>
                Crear Cuenta
              </h3>
                <p className="rs-form-subtitle" style={{ color: 'rgba(220,235,255,0.7)', fontSize: '0.92rem', marginTop: 6 }}>
                Completa los datos para registrarte en el sistema
              </p>
            </div>

            <form onSubmit={enviar} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>

              {/* Nombre / Apellido */}
                <div className="rs-form-row">
                <div style={fieldStyle}>
                  <label style={labelStyle}>Nombre</label>
                  <div style={inputBox}>
                    <span style={iconBox}><FontAwesomeIcon icon={faUser} /></span>
                    <input style={inputEl} type="text" placeholder="Juan"
                      value={nombre} onChange={e => setNombre(e.target.value)} />
                  </div>
                </div>
                <div style={fieldStyle}>
                  <label style={labelStyle}>Apellido</label>
                  <div style={inputBox}>
                    <span style={iconBox}><FontAwesomeIcon icon={faUser} /></span>
                    <input style={inputEl} type="text" placeholder="López"
                      value={apellido} onChange={e => setApellido(e.target.value)} />
                  </div>
                </div>
              </div>

              {/* Usuario / Correo */}
                <div className="rs-form-row">
                <div style={fieldStyle}>
                  <label style={labelStyle}>Nombre de Usuario</label>
                  <div style={inputBox}>
                    <span style={iconBox}><FontAwesomeIcon icon={faIdBadge} /></span>
                    <input style={inputEl} type="text" placeholder="Juan López"
                      value={nombreUsuario} onChange={e => setNombreUsuario(e.target.value)} />
                  </div>
                </div>
                <div style={fieldStyle}>
                  <label style={labelStyle}>Correo Electrónico</label>
                  <div style={inputBox}>
                    <span style={iconBox}><FontAwesomeIcon icon={faEnvelope} /></span>
                    <input style={inputEl} type="email" placeholder="juanlopez@gmail.com"
                      value={correo} onChange={e => setCorreo(e.target.value)} />
                  </div>
                </div>
              </div>

              {/* Contraseña / Confirmar */}
                <div className="rs-form-row">
                <div style={fieldStyle}>
                  <label style={labelStyle}>Contraseña</label>
                  <div style={inputBox}>
                    <span style={iconBox}><FontAwesomeIcon icon={faLock} /></span>
                    <input style={inputEl} type={verPass ? 'text' : 'password'}
                      placeholder="********" value={contrasena}
                      onChange={e => setContrasena(e.target.value)} />
                    <button type="button" style={eyeBtn} tabIndex={-1}
                      onMouseEnter={e => e.currentTarget.style.color='#5ca2ff'}
                      onMouseLeave={e => e.currentTarget.style.color='#1f3e67'}
                      onClick={() => setVerPass(v => !v)}
                      aria-label={verPass ? 'Ocultar' : 'Ver'}>
                      <FontAwesomeIcon icon={verPass ? faEyeSlash : faEye} />
                    </button>
                  </div>
                </div>
                <div style={fieldStyle}>
                  <label style={labelStyle}>Confirmar Contraseña</label>
                  <div style={inputBox}>
                    <span style={iconBox}><FontAwesomeIcon icon={faLock} /></span>
                    <input style={inputEl} type={verPass2 ? 'text' : 'password'}
                      placeholder="********" value={cContrasena}
                      onChange={e => setCContrasena(e.target.value)} />
                    <button type="button" style={eyeBtn} tabIndex={-1}
                      onMouseEnter={e => e.currentTarget.style.color='#5ca2ff'}
                      onMouseLeave={e => e.currentTarget.style.color='#1f3e67'}
                      onClick={() => setVerPass2(v => !v)}
                      aria-label={verPass2 ? 'Ocultar' : 'Ver'}>
                      <FontAwesomeIcon icon={verPass2 ? faEyeSlash : faEye} />
                    </button>
                  </div>
                </div>
              </div>

              {/* Teléfono / Edificio */}
                <div className="rs-form-row">
                <div style={fieldStyle}>
                  <label style={labelStyle}>Teléfono</label>
                  <div style={inputBox}>
                    <span style={iconBox}><FontAwesomeIcon icon={faPhone} /></span>
                    <input style={inputEl} type="text" placeholder="####-####"
                      value={telefono} onChange={e => setTelefono(e.target.value)} />
                  </div>
                </div>
                <div style={fieldStyle}>
                  <label style={labelStyle}>Edificio</label>
                  <div style={inputBox}>
                    <span style={iconBox}><FontAwesomeIcon icon={faBuilding} /></span>
                    <select style={selectEl} onChange={async (e) => {
                      const nombre = e.target.value;
                      const res2 = await fetch(`${api}/instituciones`, {
                        method: 'put', headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ nombre }),
                      });
                      const data = await res2.json();
                      setInstituciones(data);
                      setEdificio(nombre);
                    }}>
                      <option>Seleccione una Opción</option>
                      <option>Torre 1</option>
                      <option>Torre 2</option>
                      <option>CBB</option>
                      <option>CBC</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Institución / Área */}
                <div className="rs-form-row">
                <div style={fieldStyle}>
                  <label style={labelStyle}>Institución</label>
                  <div style={inputBox}>
                    <span style={iconBox}><FontAwesomeIcon icon={faBuilding} /></span>
                    <select style={selectEl} onChange={e => {
                      const seleccionada = e.target.value;
                      setInstitucion(seleccionada);
                    }}>
                      <option>Seleccione una Opción</option>
                      {instituciones.map(l => (
                        <option key={l.nombre_Institucion}>{l.nombre_Institucion}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div style={fieldStyle}>
                  <label style={labelStyle}>Área de Trabajo</label>
                  <div style={inputBox}>
                    <span style={iconBox}><FontAwesomeIcon icon={faBriefcase} /></span>
                    <select style={selectEl} onChange={e => setNombreArea(e.target.value)}>
                      <option>Seleccione una Opción</option>
                      {area.map(l => (
                        <option key={l.nombre_Are}>{l.nombre_Are}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Botón */}
              <button type="submit" className="boton" style={{ marginTop: 4 }}>
                Crear Cuenta
              </button>

              {/* Link login */}
              <div style={{ textAlign: 'center', marginTop: 4 }}>
                <NavLink to="/" style={{ fontSize: '0.93rem', fontWeight: 600, color: '#9ec7ff', textDecoration: 'none' }}>
                  ¿Ya tienes cuenta? Inicia sesión
                </NavLink>
              </div>

            </form>
          </div>
        </div>
      </Contenedorimagen2>
    </div>
  );
}

export default Formulario;
